import React from "react";
import { BordonaAppBar } from "./BordonaAppBar";
import { AmbientGlow } from "../home/AmbientGlow";
import { StellarDust } from "../home/StellarDust";
import { HOME_THEME as T } from "../../lib/homeTheme";

interface StudioLayoutProps {
  children: React.ReactNode;
  /** Sesión activa: el header del ejercicio reemplaza el AppBar global. */
  hideAppBar?: boolean;
}

/**
 * Estudio (canciones, gimnasio): app bar Serenity + atmósfera home (glow + partículas).
 */
export const StudioLayout: React.FC<StudioLayoutProps> = ({ children, hideAppBar = false }) => (
  <div
    className="relative h-screen w-screen overflow-hidden font-sans"
    style={{ backgroundColor: T.bg, color: T.text }}
  >
    <AmbientGlow />
    <StellarDust />
    {!hideAppBar && <BordonaAppBar />}
    <div className="relative z-10 h-full overflow-y-auto">{children}</div>
  </div>
);

export default StudioLayout;
